import { Column } from "@src/sharedComponents/Table/Types";

export enum ClientType {
  HOUSEHOLD = "HOUSEHOLD",
  CLIENT = "CLIENT",
}

export const popoverDropdownMenuWidth = 200;

type HouseholdAccountsTableColumnValue =
  | "accountName"
  | "number"
  | "owner"
  | "type"
  | "custodian"
  | "modelPortfolio"
  | "amount";

export const householdAccountsColumns: Column<HouseholdAccountsTableColumnValue>[] =
  [
    { accessor: "accountName", label: "Value", sortable: false },
    { accessor: "number", label: "Number", sortable: false },
    { accessor: "owner", label: "Owner", sortable: false },
    { accessor: "type", label: "Type", sortable: false },
    { accessor: "custodian", label: "Custodian", sortable: false },
    { accessor: "modelPortfolio", label: "Model Portfolio", sortable: false },
    { accessor: "amount", label: "Amount", sortable: false },
  ];

export enum AccountMenuActions {
  Rename = "rename",
  Archive = "archive",
  Delete = "delete",
}
